import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-black/20 bg-[#EFE9D9] text-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-14 h-14 bg-[#2D5F3F] flex items-center justify-center overflow-hidden">
              <img src="/assets/titans-warrior-logo.png" alt="Cawston Titans" className="w-12 h-12 object-contain" />
            </div>
            <div>
              <div className="font-display text-2xl font-black uppercase">Cawston Titans</div>
              <div className="text-xs uppercase tracking-[0.3em] text-[#2D5F3F] font-bold">Youth Sports Org</div>
            </div>
          </div>
          <p className="text-black/65 text-sm leading-relaxed max-w-md">
            Building character through competition. Football, cheer, basketball, and track & field for the next
            generation of leaders and athletes.
          </p>
        </div>

        <div>
          <h4 className="font-display uppercase tracking-[0.2em] text-xs font-bold text-[#2D5F3F] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-black/75">
            <li><Link to="/about" className="hover:text-[#2D5F3F]">About Us</Link></li>
            <li><Link to="/register" className="hover:text-[#2D5F3F]">Registration</Link></li>
            <li><Link to="/forms" className="hover:text-[#2D5F3F]">Forms</Link></li>
            <li><Link to="/coaches" className="hover:text-[#2D5F3F]">Coaches</Link></li>
            <li><Link to="/contact" className="hover:text-[#2D5F3F]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase tracking-[0.2em] text-xs font-bold text-[#2D5F3F] mb-4">Practice Field</h4>
          <ul className="space-y-3 text-sm text-black/75">
            <li className="flex gap-2"><MapPin className="w-4 h-4 text-[#2D5F3F] mt-0.5 shrink-0" /><span>Rancho Viejo Middle School<br />985 Cawston Ave N<br />Hemet, CA 92545</span></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-[#2D5F3F] mt-0.5 shrink-0" /><a href="mailto:Cawstontitans@gmail.com" className="hover:text-[#2D5F3F] break-all font-semibold">Cawstontitans@gmail.com</a></li>
            <li className="flex gap-2"><Phone className="w-4 h-4 text-[#2D5F3F] mt-0.5 shrink-0" /><a href="tel:9514013498" className="hover:text-[#2D5F3F]">(951) 401-3498</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/10 px-6 md:px-12 py-6 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 text-xs uppercase tracking-widest text-black/50">
        <span>© {new Date().getFullYear()} Cawston Titans Youth Sports Organization</span>
        <span>Built on Grit · Hemet, CA</span>
      </div>
    </footer>
  );
}
